<template>
  <el-table-column
    align="center"
    :label="$t('api.action')"
    fixed="right"
    class-name="list-action-btns"
    :width="$attrs.width"
    :min-width="$attrs.minWidth"
    >
    <template slot-scope="scope">
      <slot relBtn
        :rowid="scope.row[idField]"
        :rowname="scope.row[nameField]"
        :row="scope.row"
        >
      </slot>
      <act-btn
        v-if="isReadOnly"
        :tip="transText(name + '.viewBtn')"
        icon="el-icon-document"
        @click="gotoPage('./edit/' + scope.row[idField])"
        >
      </act-btn>
      <act-btn
        v-else
        :tip="transText(name + '.editBtn')"
        icon="el-icon-edit"
        @click="gotoPage('./edit/' + scope.row[idField])"
        >
      </act-btn>
      <act-btn
        v-if="showDisBtn(scope.row)"
        :tip="transText(name + '.disBtn')"
        type="danger"
        iconClass="baseline-not_interested-24px"
        @click="updStatus(scope.row, hiddenStatus)"
        >
      </act-btn>
      <act-btn
        v-if="showBanBtn(scope.row)"
        :tip="transText(name + '.banBtn')"
        type="danger"
        iconClass="visibility_off-24px"
        @click="updStatus(scope.row, hiddenStatus)"
        >
      </act-btn>
      <act-btn
        v-if="showPublishBtn(scope.row)"
        :tip="transText(name + '.publishBtn')"
        type="success"
        iconClass="publish-24px"
        @click="updStatus(scope.row, publishStatus)"
        >
      </act-btn>
      <act-btn
        v-if="showNoSaleBtn(scope.row)"
        :tip="transText(name + '.noSaleBtn')"
        type="danger"
        icon="el-icon-remove"
        @click="updStatus(scope.row, noSaleStatus)"
        >
      </act-btn>
      <act-btn
        v-if="showBackBtn(scope.row)"
        :tip="transText(name + '.backNormalBtn')"
        type="warning"
        icon="el-icon-refresh-left"
        @click="updStatus(scope.row, backStatus)"
        >
      </act-btn>
      <act-btn
        v-if="showDelBtn(scope.row)"
        :tip="transText(name + '.delBtn')"
        type="danger"
        icon="el-icon-delete"
        @click="deleteItem(scope.row)"
        >
      </act-btn>
    </template>
  </el-table-column>
</template>

<script>

import { transText } from '@/utils/i18n'

export default {
  name: 'act-col',
  props: {
    name: {
      type: String,
      required: true
    },
    idText: {
      type: String,
      default: 'ID'
    },
    idField: {
      type: String,
      default: 'id'
    },
    nameField: {
      type: String,
      default: 'name'
    },
    titleField: {
      type: String,
      default: 'title'
    },
    type: {
      type: String,
      default: 'default'
    },
    platform: {
      type: String
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    isShowDelBtn: {
      type: Boolean,
      default: false
    },
    isNoDelBtn: {
      type: Boolean,
      default: false
    },
    updateStatus: {
      type: Function,
      required: false
    },
    deleteOne: {
      type: Function,
      required: false
    },
    getList: {
      type: Function,
      required: true
    },
    showDelBtnFunc: {
      type: Function,
      required: false
    },
    delActFunc: {
      type: Function,
      required: false
    }
  },
  data () {
    return {
      defStatus: 0,
      backStatus: 0,
      hiddenStatus: 1,
      publishStatus: 1,
      noSaleStatus: 2
    }
  },
  mounted () {
    switch (this.type) {
      case 'blog':
        this.backStatus = 1
        this.hiddenStatus = 2
        this.noSaleStatus = -1
        break
      case 'product':
        this.hiddenStatus = 4
    }
  },
  computed: {
    isNoDisable () {
      return this.type === 'no-disable'
    }
  },
  methods: {
    transText,
    isShowHide () {
      switch (this.type) {
        case 'show':
        case 'product':
        case 'category':
          return true
        case 'blog':
          return true
      }
      return false
    },
    checkStatus (data, def) {
      if (this.isReadOnly ||
        typeof this.updateStatus === 'undefined' ||
        typeof data['status'] === 'undefined') {
        return false
      }
      return def
    },
    showBackBtn (data) {
      switch (this.type) {
        case 'blog':
          return this.checkStatus(data, data['status'] === this.hiddenStatus)
        case 'product':
        case 'category':
          return this.checkStatus(data, data['status'] !== this.defStatus)
      }
      return false
    },
    showPublishBtn (data) {
      if (this.type !== 'blog') {
        return false
      }
      return this.checkStatus(data, data['status'] === this.defStatus)
    },
    showNoSaleBtn (data) {
      switch (this.type) {
        case 'product':
        case 'category':
          return this.checkStatus(data, data['status'] === this.defStatus)
        default:
          return false
      }
    },
    showDisBtn (data) {
      if (this.isNoDisable) {
        return false
      }
      return this.checkStatus(data, data['status'] === this.defStatus) && !this.isShowHide()
    },
    showBanBtn (data) {
      if (this.isNoDisable) {
        return false
      }
      if (this.type === 'blog') {
        return data['status'] !== 2
      }
      return this.checkStatus(data, data['status'] === this.defStatus) && this.isShowHide()
    },
    showDelBtn (data) {
      if (this.isNoDelBtn) {
        return false
      }
      if (this.isShowDelBtn) {
        return true
      }
      if (typeof this.showDelBtnFunc !== 'undefined') {
        return this.showDelBtnFunc(data)
      }
      if (this.isReadOnly ||
        typeof this.deleteOne === 'undefined') {
        return false
      }
      if (typeof data['status'] === 'undefined') {
        return true
      }
      if (this.type === 'blog') {
        return data['status'] !== 1
      }
      return data['status'] !== this.defStatus
    },
    gotoPage (path) {
      this.$router.push({ path: path })
    },
    htmlencode (s) {
      var div = document.createElement('div')
      div.appendChild(document.createTextNode(s))
      return div.innerHTML
    },
    updStatus (item, status) {
      var attr = {
        id: item[this.idField],
        name: this.htmlencode(item[this.nameField]),
        idText: this.idText,
        dataText: this.$t('api.' + this.name + '.name')
      }
      var msg = this.transText(this.name + '.disConfirmMsg', attr)
      var title = this.transText(this.name + '.disConfirmTitle')
      var successMsg = this.transText(this.name + '.disSuccess')
      if (this.isShowHide()) {
        switch (status) {
          case this.backStatus:
            if (item.status === this.defStatus) {
              msg = this.transText(this.name + '.publishConfirmMsg', attr)
              title = this.transText(this.name + '.publishConfirmTitle')
              successMsg = this.transText(this.name + '.publishNormalSuccess')
              break
            }
            msg = this.transText(this.name + '.backConfirmMsg', attr)
            title = this.transText(this.name + '.backConfirmTitle')
            successMsg = this.transText(this.name + '.backNormalSuccess')
            break
          case this.noSaleStatus:
            msg = this.transText(this.name + '.noSaleConfirmMsg', attr)
            title = this.transText(this.name + '.noSaleConfirmTitle')
            successMsg = this.transText(this.name + '.noSaleSuccess')
            break
          default:
            msg = this.transText(this.name + '.banConfirmMsg', attr)
            title = this.transText(this.name + '.banConfirmTitle')
            successMsg = this.transText(this.name + '.banSuccess')
        }
      }
      this.$confirm(msg, title, {
        confirmButtonText: this.$t('api.confirmBtn'),
        cancelButtonText: this.$t('api.cancelBtn'),
        confirmButtonClass: 'el-button--danger',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.disabled = false
        this.listLoading = true
        this.updateStatus(item[this.idField], { status: status }, this.platform).then(response => {
          this.$message({
            message: successMsg,
            type: 'success',
            duration: 2000
          })
          this.getList()
        }).catch(err => {
          console.log(err)
        }).then(() => {
          this.listLoading = false
        })
      })
    },
    deleteItem (item) {
      this.$confirm(this.transText(this.name + '.delConfirmMsg', {
        id: item[this.idField],
        name: item[this.nameField],
        title: item[this.titleField],
        idText: this.idText,
        dataText: this.$t('api.' + this.name + '.name')
      }), this.transText(this.name + '.delConfirmTitle'), {
        confirmButtonText: this.$t('api.confirmBtn'),
        cancelButtonText: this.$t('api.cancelBtn'),
        confirmButtonClass: 'el-button--danger',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.listLoading = true
        let id = item[this.idField]
        this.deleteOne(id, this.platform).then(res => {
          if (this.delActFunc) {
            if (this.delActFunc(res, id)) {
              return
            }
          }
          this.$message({
            message: this.transText(this.name + '.delSuccess'),
            type: 'success',
            duration: 2000
          })
          this.getList()
        }).catch(err => {
          console.log(err)
        }).then(() => {
          this.listLoading = false
        })
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
